import { Link, To } from 'react-router-dom';
import { ReactNode } from 'react';

type BLinkProps = {
  to: To;
  activateLink: boolean;
  className?: string;
  children: ReactNode;  
};

export function BLink({ to, activateLink, className, children }: BLinkProps) {
  if (!activateLink) {
    return <>{children}</>;
  }

  return (
    <Link to={to} target="_blank" className={className} style={{ cursor: 'pointer' }}>
      {children}
    </Link>
  );
}
